import { useContext } from 'react';

import { LoginContext } from '../context';
import DraftsIcon from '@mui/icons-material/Drafts';
import { Box, Button, Paper, Typography } from '@mui/material';
import logo from '@assets/logo_landing_page.svg';

interface IResendMagicLinkEmailProps {
  email: string;
  setEmail: (email: string) => void;
}

export const ResendMagicLinkEmail = ({
  email,
  setEmail,
}: IResendMagicLinkEmailProps) => {
  const { handlePreviousStep } = useContext(LoginContext);

  const handleResend = () => {
    setEmail('');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '3.5rem',
        width: '28rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <img
          src={logo}
          style={{
            objectFit: 'cover',
            height: '131px',
            width: '132px',
          }}
          alt='logo'
        />
      </Box>
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '2rem',
          gap: '1rem',
          width: '100%',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
            padding: 0,
          }}
        >
          <DraftsIcon sx={{ fontSize: '3rem' }} color='primary' />
          <Typography
            sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
          >
            Check your email
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 'regular',
              paddingBottom: '4px',
              textAlign: 'center',
            }}
          >
            We've sent an email containing a sign-in link to: {email}. The link
            will expire in 15 minutes.
          </Typography>
        </Box>

        <Button
          variant='outlined'
          sx={{ padding: '0.5rem', fontWeight: '500' }}
          onClick={handleResend}
          fullWidth
        >
          RESEND
        </Button>

        <Button
          variant='text'
          sx={{ padding: '0.5rem', fontWeight: '500' }}
          onClick={handlePreviousStep}
          fullWidth
        >
          USE PASSWORD
        </Button>
      </Paper>
    </Box>
  );
};
